/* First-party product reviews (snippets/wf-reviews.liquid).
   Page 1 is server-rendered from the wf_reviews.widget metafield; this adds:
   - rating filter (histogram buttons), sort, search, Load more, all via
     GET /apps/wf/reviews/products/ (Shopify app proxy -> backend), each
     update announced in the section's role="status" region;
   - "Read more" for long reviews (a real button with aria-expanded);
   - the Write-a-review <dialog>: POST /apps/wf/reviews/submit/ (Judge.me
     collects; the backend dry-runs until launch).
   reviewHtml() must stay in sync with snippets/wf-review-item.liquid. */
(function () {
  'use strict';

  var API = '/apps/wf/reviews/';
  var STAR = 'M12 2.6l2.87 5.82 6.43.93-4.65 4.53 1.1 6.4L12 17.26l-5.75 3.02 1.1-6.4L2.7 9.35l6.43-.93z';
  var WORDS = { 1: 'Poor', 2: 'Fair', 3: 'Good', 4: 'Great', 5: 'Love it!' };
  var CLAMP_CHARS = 420;
  var nf = new Intl.NumberFormat('en-US');

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function plural(n, one, many) { return n === 1 ? one : many; }
  function reviewsWord(n) { return plural(n, 'review', 'reviews'); }

  function starsHtml(rating, size) {
    var svg = '<svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="' + STAR + '"/></svg>';
    var row = svg + svg + svg + svg + svg;
    return '<span class="wf-stars wf-stars--' + size + '" role="img" aria-label="Rated ' + rating + ' out of 5 stars">' +
      '<span class="wf-stars__row">' + row + '</span>' +
      '<span class="wf-stars__row wf-stars__row--fill" style="width: ' + (rating * 20) + '%">' + row + '</span></span>';
  }

  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso + 'T12:00:00');
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function initials(name) {
    var parts = String(name || '').split(' ').filter(Boolean);
    var s = (parts[0] || '').charAt(0) + (parts.length > 1 ? parts[parts.length - 1].charAt(0) : '');
    return s.toUpperCase();
  }

  function nl2br(s) { return esc(s).replace(/\r?\n/g, '<br>'); }

  function reviewHtml(r) {
    return '<li class="wf-review" tabindex="-1">' +
      '<div class="wf-review__meta">' +
        '<span class="wf-review__avatar" aria-hidden="true">' + esc(initials(r.name)) + '</span>' +
        '<div class="wf-review__who">' +
          '<p class="wf-review__name">' + esc(r.name) + '</p>' +
          (r.location ? '<p class="wf-review__loc">' + esc(r.location) + '</p>' : '') +
          (r.verified ? '<p class="wf-review__verified"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10"/><path d="M7.5 12.3l3 3 6-6.3"/></svg>Verified buyer</p>' : '') +
        '</div>' +
      '</div>' +
      '<div class="wf-review__content">' +
        '<div class="wf-review__top">' + starsHtml(r.rating, 'md') +
          (r.date ? '<time class="wf-review__date" datetime="' + esc(r.date) + '">' + esc(fmtDate(r.date)) + '</time>' : '') +
        '</div>' +
        (r.title ? '<h3 class="wf-review__title">' + esc(r.title) + '</h3>'
                 : '<h3 class="visually-hidden">Review by ' + esc(r.name) + '</h3>') +
        '<p class="wf-review__body">' + nl2br(r.body) + '</p>' +
        (r.reply ? '<div class="wf-review__reply"><p class="wf-review__reply-head"><span class="wf-review__mono" aria-hidden="true">WF</span> Wear Felicity replied</p><p>' + nl2br(r.reply.body) + '</p></div>' : '') +
      '</div></li>';
  }

  var uid = 0;
  function clamp(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('.wf-review__body:not([data-wf-clamped])'), function (p) {
      p.setAttribute('data-wf-clamped', '');
      if (p.textContent.length <= CLAMP_CHARS) return;
      if (!p.id) p.id = 'WfReviewBody' + (++uid);
      p.classList.add('is-clamped');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wf-review__more';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', p.id);
      btn.textContent = 'Read more';
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        p.classList.toggle('is-clamped', open);
        btn.setAttribute('aria-expanded', String(!open));
        btn.textContent = open ? 'Read more' : 'Show less';
      });
      p.insertAdjacentElement('afterend', btn);
    });
  }

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  /* Mobile chip row: nudge the row's start offset, the gaps and the chips' side
     padding (within small ranges) so the chip at the screen edge peeks about a
     quarter, a cue that the row scrolls. Gaps alone can't always do it: a chip
     can end right at the edge. No-op when the chips all fit (desktop wraps). */
  function peekChips(row) {
    var chips = Array.prototype.slice.call(row.children);
    row.style.columnGap = '';
    row.style.paddingLeft = '';
    chips.forEach(function (c) { c.style.paddingLeft = c.style.paddingRight = ''; });
    if (!chips.length || row.scrollWidth <= row.clientWidth + 1) return;
    var cs = getComputedStyle(chips[0]);
    var sidePad = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
    var content = chips.map(function (c) { return c.offsetWidth - sidePad; });
    var edge = row.clientWidth, best = null;
    for (var p = 16; p <= 24; p++) {
      for (var g = 6; g <= 16; g++) {
        for (var h = 10; h <= 18; h++) {
          var x = p;
          for (var k = 0; k < chips.length; k++) {
            var w = content[k] + 2 * h;
            if (x + w > edge) {
              var shown = (edge - x) / w;
              var score = Math.abs(shown - 0.25) * 100 + Math.abs(h - 16) * 0.5 + Math.abs(g - 8) * 0.3 + Math.abs(p - 20) * 0.2;
              if (shown > 0 && (!best || score < best.score)) best = { score: score, p: p, g: g, h: h, shown: shown };
              break;
            }
            x += w + g;
          }
        }
      }
    }
    if (!best || Math.abs(best.shown - 0.25) > 0.1) return;
    row.style.paddingLeft = best.p + 'px';
    row.style.columnGap = best.g + 'px';
    chips.forEach(function (c) { c.style.paddingLeft = c.style.paddingRight = best.h + 'px'; });
  }

  /* "What Customers Are Saying": Read more only when the 4-line clamp cuts text. */
  function summaryMore(root) {
    var text = root.querySelector('[data-wf-say]');
    var btn = root.querySelector('[data-wf-say-more]');
    if (!text || !btn) return;
    var check = function () {
      if (!text.classList.contains('is-open')) btn.hidden = text.scrollHeight <= text.clientHeight + 1;
    };
    check();
    window.addEventListener('resize', debounce(check, 150));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
    btn.addEventListener('click', function () {
      var open = !text.classList.contains('is-open');
      text.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? 'Show less' : 'Read more';
    });
  }

  function Reviews(root) {
    this.root = root;
    this.pid = root.getAttribute('data-product-id');
    this.handle = root.getAttribute('data-handle');
    this.total = parseInt(root.getAttribute('data-count'), 10) || 0;
    var sortSelect = root.querySelector('[data-wf-sort]');
    this.state = { page: 1, rating: null, topic: '', topicLabel: '', sort: sortSelect ? sortSelect.value : 'featured', q: '', total: this.total };
    this.list = root.querySelector('[data-wf-list]');
    this.status = root.querySelector('[data-wf-status]');
    this.more = root.querySelector('[data-wf-more]');
    this.clearChip = root.querySelector('[data-wf-clear]');
    this.filterLabel = root.querySelector('[data-wf-filter-label]');
    this.hist = Array.prototype.slice.call(root.querySelectorAll('[data-wf-rating]'));
    this.topics = Array.prototype.slice.call(root.querySelectorAll('[data-wf-topic]'));
    this.busy = false;
    if (this.list) {
      this.loaded = this.list.children.length;
      clamp(this.list);
      this.bindBrowse();
    }
    summaryMore(root);
    var topics = root.querySelector('[data-wf-topics]');
    if (topics) {
      var repeek = function () { peekChips(topics); };
      repeek();
      window.addEventListener('resize', debounce(repeek, 150));
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(repeek);
    }
    new WriteDialog(root, this);
  }

  Reviews.prototype.bindBrowse = function () {
    var self = this;
    this.hist.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var r = parseInt(btn.getAttribute('data-wf-rating'), 10);
        self.lastTrigger = btn;
        self.setFilter(self.state.rating === r ? null : r);
      });
    });
    this.topics.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-wf-topic');
        var on = self.state.topic !== key;
        self.lastTrigger = btn;
        self.state.topic = on ? key : '';
        self.state.topicLabel = on ? btn.getAttribute('data-wf-topic-label') : '';
        self.syncPressed();
        self.reload();
      });
    });
    if (this.clearChip) this.clearChip.addEventListener('click', function () {
      // The chip hides itself, so move focus somewhere sensible: back to the
      // chip/star row that set the filter, else the first review. Never a
      // <select> or text input: on phones focusing those opens the picker/keyboard.
      var back = self.lastTrigger;
      self.clearAll(function () {
        var target = back && document.contains(back) ? back : self.list.querySelector('.wf-review');
        if (target) target.focus({ preventScroll: true });
      });
    });
    var sort = this.root.querySelector('[data-wf-sort]');
    if (sort) sort.addEventListener('change', function () { self.state.sort = sort.value; self.reload(); });
    var search = this.root.querySelector('[data-wf-search]');
    if (search) {
      var input = search.querySelector('input');
      search.addEventListener('submit', function (e) {
        e.preventDefault();
        self.state.q = input.value.trim();
        self.lastTrigger = null;
        self.reload();
      });
      input.addEventListener('search', function () { if (!input.value) { self.state.q = ''; self.reload(); } });
    }
    if (this.more) this.more.addEventListener('click', function () { self.loadMore(); });
  };

  Reviews.prototype.setFilter = function (rating) {
    this.state.rating = rating;
    this.syncPressed();
    this.reload();
  };

  Reviews.prototype.clearAll = function (done) {
    var s = this.state;
    s.rating = null; s.topic = ''; s.topicLabel = ''; s.q = '';
    var input = this.root.querySelector('[data-wf-search] input');
    if (input) input.value = '';
    this.lastTrigger = null;
    this.syncPressed();
    this.reload(done);
  };

  Reviews.prototype.syncPressed = function () {
    var s = this.state;
    this.hist.forEach(function (b) {
      b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-wf-rating'), 10) === s.rating));
    });
    this.topics.forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-wf-topic') === s.topic));
    });
  };

  Reviews.prototype.syncChips = function () {
    var s = this.state, label = '';
    if (s.rating) label = s.rating + ' ' + plural(s.rating, 'star', 'stars');
    if (s.topicLabel) label = (label ? label + ' · ' : '') + s.topicLabel;
    if (s.q) label = (label ? label + ' · ' : '') + '“' + s.q + '”';
    if (this.clearChip) {
      this.clearChip.hidden = !label;
      this.filterLabel.textContent = label;
    }
  };

  Reviews.prototype.fetchPage = function (page) {
    var s = this.state;
    var params = new URLSearchParams({ product: this.pid, handle: this.handle, page: String(page), sort: s.sort });
    if (s.rating) params.set('rating', String(s.rating));
    if (s.topic) params.set('topic', s.topic);
    if (s.q) params.set('q', s.q);
    return fetch(API + 'products/?' + params.toString(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  };

  Reviews.prototype.describe = function () {
    var s = this.state, n = s.total;
    var what = (s.rating ? s.rating + '-star ' : '') + reviewsWord(n);
    if (s.topicLabel) what += ' mentioning ' + s.topicLabel.toLowerCase();
    if (s.q) what += ' matching “' + s.q + '”';
    return 'Showing ' + nf.format(Math.min(this.loaded, n)) + ' of ' + nf.format(n) + ' ' + what;
  };

  Reviews.prototype.updateMore = function () {
    if (this.more) this.more.hidden = this.loaded >= this.state.total;
  };

  Reviews.prototype.reload = function (done) {
    var self = this;
    if (this.busy) return;
    this.busy = true;
    this.syncChips();
    this.list.classList.add('is-loading');
    this.list.setAttribute('aria-busy', 'true');
    this.fetchPage(1).then(function (data) {
      self.state.page = 1;
      self.state.total = data.count;
      self.list.innerHTML = data.reviews.map(reviewHtml).join('');
      self.loaded = data.reviews.length;
      clamp(self.list);
      self.status.textContent = data.count ? self.describe() : 'No reviews match these filters.';
      self.updateMore();
      if (done) done();
    }).catch(function () {
      self.status.textContent = 'Sorry, reviews couldn’t load. Please try again.';
    }).then(function () {
      self.busy = false;
      self.list.classList.remove('is-loading');
      self.list.removeAttribute('aria-busy');
    });
  };

  Reviews.prototype.loadMore = function () {
    var self = this;
    if (this.busy) return;
    this.busy = true;
    this.more.disabled = true;
    this.more.textContent = 'Loading…';
    this.fetchPage(this.state.page + 1).then(function (data) {
      self.state.page = data.page;
      self.state.total = data.count;
      var start = self.list.children.length;
      self.list.insertAdjacentHTML('beforeend', data.reviews.map(reviewHtml).join(''));
      self.loaded = self.list.children.length;
      clamp(self.list);
      self.status.textContent = 'Loaded ' + data.reviews.length + ' more. ' + self.describe() + '.';
      var first = self.list.children[start];
      if (first) first.focus();
      self.updateMore();
    }).catch(function () {
      self.status.textContent = 'Sorry, more reviews couldn’t load. Please try again.';
    }).then(function () {
      self.busy = false;
      self.more.disabled = false;
      self.more.textContent = 'Load more reviews';
    });
  };

  /* ---------- Write a review ---------- */
  function WriteDialog(root, reviews) {
    var self = this;
    this.reviews = reviews;
    this.dialog = root.querySelector('[data-wf-dialog]');
    if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
    this.form = this.dialog.querySelector('[data-wf-form]');
    this.done = this.dialog.querySelector('[data-wf-done]');
    this.errors = this.dialog.querySelector('[data-wf-errors]');
    this.stars = this.dialog.querySelector('.wf-rate__stars');
    this.word = this.dialog.querySelector('[data-wf-rate-word]');
    this.count = this.dialog.querySelector('[data-wf-count]');
    this.submit = this.dialog.querySelector('[data-wf-submit]');
    this.trigger = null;

    Array.prototype.forEach.call(root.querySelectorAll('[data-wf-write]'), function (btn) {
      btn.addEventListener('click', function () { self.open(btn); });
    });
    Array.prototype.forEach.call(this.dialog.querySelectorAll('[data-wf-close]'), function (btn) {
      btn.addEventListener('click', function () { self.dialog.close(); });
    });
    // Esc and close() both fire "close": always hand focus back to the trigger.
    this.dialog.addEventListener('close', function () {
      if (self.trigger && document.contains(self.trigger)) self.trigger.focus();
    });
    this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.dialog.close(); });

    var radios = this.form.querySelectorAll('input[name="rating"]');
    Array.prototype.forEach.call(radios, function (radio) {
      radio.addEventListener('change', function () { self.showRating(radio.value); self.clearError('rating'); });
      var label = radio.nextElementSibling;
      label.addEventListener('mouseenter', function () { self.stars.setAttribute('data-value', radio.value); });
      label.addEventListener('mouseleave', function () { self.showRating(self.checkedRating()); });
    });
    var body = this.form.elements.body;
    body.addEventListener('input', function () { self.count.textContent = nf.format(body.value.length) + ' / 2,000'; });
    Array.prototype.forEach.call(this.form.querySelectorAll('input, textarea'), function (el) {
      el.addEventListener('input', function () { self.clearError(el.name); });
    });
    this.form.addEventListener('submit', function (e) { e.preventDefault(); self.send(); });
  }

  WriteDialog.prototype.checkedRating = function () {
    var c = this.form.querySelector('input[name="rating"]:checked');
    return c ? c.value : '';
  };

  WriteDialog.prototype.showRating = function (value) {
    if (value) {
      this.stars.setAttribute('data-value', value);
      this.word.textContent = WORDS[value];
    } else {
      this.stars.removeAttribute('data-value');
      this.word.textContent = 'Select 1 to 5 stars';
    }
  };

  WriteDialog.prototype.open = function (trigger) {
    this.trigger = trigger;
    if (!this.done.hidden) this.reset();
    this.dialog.showModal();
    this.dialog.querySelector('.wf-review-dialog__title').focus();
  };

  WriteDialog.prototype.reset = function () {
    this.form.reset();
    this.showRating('');
    this.count.textContent = '0 / 2,000';
    this.form.hidden = false;
    this.done.hidden = true;
    this.errors.hidden = true;
    ['rating', 'title', 'body', 'name', 'email'].forEach(this.clearError, this);
  };

  WriteDialog.prototype.clearError = function (field) {
    var p = this.form.querySelector('[data-wf-error="' + field + '"]');
    if (p) { p.hidden = true; p.textContent = ''; }
    var el = this.form.elements[field];
    if (el && el.removeAttribute) el.removeAttribute('aria-invalid');
  };

  WriteDialog.prototype.showErrors = function (errors) {
    var first = null, self = this;
    Object.keys(errors).forEach(function (field) {
      var p = self.form.querySelector('[data-wf-error="' + field + '"]');
      if (p) { p.textContent = errors[field]; p.hidden = false; }
      var el = field === 'rating' ? self.form.querySelector('input[name="rating"]') : self.form.elements[field];
      if (el && field !== 'rating') el.setAttribute('aria-invalid', 'true');
      if (!first && el) first = el;
    });
    var n = Object.keys(errors).length;
    this.errors.textContent = 'Please fix ' + n + ' ' + plural(n, 'field', 'fields') + ' below.';
    this.errors.hidden = false;
    if (first) first.focus();
  };

  WriteDialog.prototype.validate = function (d) {
    var e = {};
    if (!d.rating) e.rating = 'Choose a rating from 1 to 5 stars.';
    if (!d.body) e.body = 'Please write your review.';
    if (!d.name) e.name = 'Please enter the name to show on your review.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.email)) e.email = 'Please enter a valid email address.';
    return e;
  };

  WriteDialog.prototype.send = function () {
    var self = this, f = this.form.elements;
    var data = {
      rating: parseInt(this.checkedRating(), 10) || null,
      title: f.title.value.trim(), body: f.body.value.trim(),
      name: f.name.value.trim(), email: f.email.value.trim(),
      website: f.website.value,
      product: this.reviews.pid, handle: this.reviews.handle
    };
    var errs = this.validate(data);
    if (Object.keys(errs).length) { this.showErrors(errs); return; }
    this.errors.hidden = true;
    this.submit.disabled = true;
    this.submit.textContent = 'Sending…';
    fetch(API + 'submit/', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, body: j }; });
    }).then(function (res) {
      if (res.body && res.body.ok) { self.success(data.name); return; }
      if (res.body && res.body.errors) { self.showErrors(res.body.errors); return; }
      self.errors.textContent = (res.body && res.body.error) || 'Sorry, something went wrong. Please try again.';
      self.errors.hidden = false;
    }).catch(function () {
      self.errors.textContent = 'Sorry, we couldn’t send your review. Please check your connection and try again.';
      self.errors.hidden = false;
    }).then(function () {
      self.submit.disabled = false;
      self.submit.textContent = 'Submit review';
    });
  };

  WriteDialog.prototype.success = function (name) {
    var first = String(name).split(' ')[0];
    this.form.hidden = true;
    this.done.hidden = false;
    var title = this.done.querySelector('[data-wf-done-title]');
    title.textContent = first ? 'Thank you, ' + first + '!' : 'Thank you!';
    title.focus();
  };

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-wf-reviews]:not([data-wf-ready])'), function (root) {
      root.setAttribute('data-wf-ready', '');
      new Reviews(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
